import { Injectable } from '@angular/core';
import { RadioSettingsService } from '@se/platform';
import { RadioSettings, VnaSettings, PacsSettingBox, PacsSettingRole } from 'estensa-module';
import { firstValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class ConfigurationService {
    private stowsUriDicom: string;
    private stowsUriDicomWeb: string;

    private aet: string = '';

    constructor(readonly settingService: RadioSettingsService) {
        this.populateStowsUri();
    }

    private populateStowsUri() {
        firstValueFrom(this.settingService.radioSettingsAsync).then((settings) => {
            this.stowsUriDicom = this.retriveStowsUriOnlyArchive(this.getVnaSettings(settings));
            this.stowsUriDicomWeb = this.retriveStowsUriSWFArchive(this.getVnaSettings(settings));
        });
    }

    private getVnaSettings(radioSettings: RadioSettings): VnaSettings {
        if (!radioSettings) {
            throw new Error('radio settings assenti');
        }
        return radioSettings.vnaSettings;
    }

    private retriveStowsUriOnlyArchive(vnaSettings: VnaSettings): string {
        this.checkVnaSettingBox(vnaSettings);
        let stoswUri = '';
        vnaSettings.vnaSettingBoxList.map((item) => {
            if (item.enable && item.pacsRole === PacsSettingRole.OnlyArchive) {
                stoswUri = item.stowsUri;
            }
        })
        return stoswUri;
    }

    private retriveStowsUriSWFArchive(vnaSettings: VnaSettings): string {
        this.checkVnaSettingBox(vnaSettings);
        let stoswUri = '';
        vnaSettings.vnaSettingBoxList.map((item) => {
            if (item.enable && item.pacsRole === PacsSettingRole.SWFArchive) {
                stoswUri = item.stowsUri;
                return this.aet = item.aet;
            }
        })
        return stoswUri;
    }
    

    private checkVnaSettingBox(vnaSettings: VnaSettings) {
        if (!vnaSettings) {
            throw new Error('vna settings assenti');
        }

        let vnaSettingBoxList = vnaSettings.vnaSettingBoxList;
        if (!vnaSettingBoxList) {
            throw new Error('vnaSettingBoxList settings assenti');
        }

        let vnaSettingBoxEnable = vnaSettings.vnaSettingBoxList.find((setting: PacsSettingBox) => setting.enable);
        if (!vnaSettingBoxEnable) {
            throw new Error('vnaSettingBoxEnable settings assente');
        }
    }

    getStowsUri(): string {
        return this.stowsUriDicom;
    }

    getStowsUriDicomWeb(): string {
        return this.stowsUriDicomWeb;
    }

    getAet(): string {
        return this.aet;
    }

}
